import { Link } from "react-router-dom";

import { useLanguage } from "../../contexts/LanguageContext";

import "./CTA.css";

const CTA = () => {
  const { t } = useLanguage();
  return (
    <section className="cta section">
      <div className="container">
        <div className="cta-content text-center fade-in">
          <h2>{t("cta.title")}</h2>
          <p>{t("cta.description")}</p>
          <div className="cta-actions">
            <Link to="/create-event" className="btn btn-primary btn-large cta-button">
              {t("cta.buttonText")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
